var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 15.9954,
    viewBox: "0 0 24 15.9954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 7.99767H16C20.4182 7.99767 24 4.41695 24 0H16C11.5818 0 8 3.58072 8 7.99767Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 15.9953H8C12.4182 15.9953 16 12.4146 16 7.99765H8C3.58176 7.99765 0 11.5784 0 15.9953Z",
    fill: "#274766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5448 11.7759C17.5448 10.4508 18.6194 9.37659 19.9448 9.37659C21.2703 9.37659 22.3448 10.4508 22.3448 11.7759C22.3448 13.1009 21.2703 14.1752 19.9448 14.1752C18.6194 14.1752 17.5448 13.1009 17.5448 11.7759Z",
    fill: "#E0D65F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.54484 4.05399C1.54484 2.72894 2.6194 1.65469 3.94484 1.65469C5.27028 1.65469 6.34484 2.72894 6.34484 4.05399C6.34484 5.37905 5.27028 6.45329 3.94484 6.45329C2.6194 6.45329 1.54484 5.37905 1.54484 4.05399Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif31);
export default __webpack_public_path__ + "static/media/motif-31.5acc5fc2f473cd3462ffc8dd03177dfb.svg";
export { ForwardRef as ReactComponent };